import type { TrailDefinition, TrailContext } from './types'

interface Bubble {
  x: number
  y: number
  vy: number
  vx: number
  life: number
  maxLife: number
  radius: number
  wobblePhase: number
  wobbleSpeed: number
}

const MAX_BUBBLES = 50

export const bubbles: TrailDefinition = {
  id: 'bubbles',
  name: 'Bubbles',

  init() {
    return [] as Bubble[]
  },

  update(state: unknown, ctx: TrailContext) {
    const bubbles = state as Bubble[]
    const dt = ctx.deltaTime / 1000

    // Spawn bubbles at mouse
    if (ctx.mouseActive && dt > 0) {
      const spawnCount = Math.min(2, MAX_BUBBLES - bubbles.length)
      for (let i = 0; i < spawnCount; i++) {
        bubbles.push({
          x: ctx.mouseX + (Math.random() - 0.5) * 12,
          y: ctx.mouseY + (Math.random() - 0.5) * 12,
          vy: -(20 + Math.random() * 40),
          vx: (Math.random() - 0.5) * 15,
          life: 1,
          maxLife: 0.6 + Math.random() * 0.6,
          radius: 4 + Math.random() * 10,
          wobblePhase: Math.random() * Math.PI * 2,
          wobbleSpeed: 3 + Math.random() * 3
        })
      }
    }

    // Update
    for (let i = bubbles.length - 1; i >= 0; i--) {
      const b = bubbles[i]
      b.life -= dt / b.maxLife
      b.x += b.vx * dt + Math.sin(b.wobblePhase) * 12 * dt
      b.y += b.vy * dt
      b.vy *= 0.99
      b.wobblePhase += b.wobbleSpeed * dt
      // Bubbles slowly grow as they rise
      b.radius += dt * 2

      if (b.life <= 0) {
        bubbles.splice(i, 1)
      }
    }
  },

  draw(state: unknown, ctx: TrailContext) {
    const bubbles = state as Bubble[]
    const c = ctx.ctx

    for (const b of bubbles) {
      const alpha = Math.max(0, b.life)

      // Bubble body - transparent with rim
      c.beginPath()
      c.arc(b.x, b.y, b.radius, 0, Math.PI * 2)
      c.strokeStyle = `rgba(200, 220, 255, ${alpha * 0.5})`
      c.lineWidth = 1
      c.stroke()

      // Inner highlight - small white arc
      c.beginPath()
      c.arc(b.x - b.radius * 0.3, b.y - b.radius * 0.3, b.radius * 0.35, 0, Math.PI * 2)
      c.fillStyle = `rgba(255, 255, 255, ${alpha * 0.35})`
      c.fill()

      // Subtle fill
      const gradient = c.createRadialGradient(b.x, b.y, 0, b.x, b.y, b.radius)
      gradient.addColorStop(0, `rgba(180, 210, 255, ${alpha * 0.04})`)
      gradient.addColorStop(0.8, `rgba(160, 200, 255, ${alpha * 0.08})`)
      gradient.addColorStop(1, 'transparent')
      c.fillStyle = gradient
      c.beginPath()
      c.arc(b.x, b.y, b.radius, 0, Math.PI * 2)
      c.fill()
    }
  }
}
